import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import { QRCodeCanvas } from "qrcode.react";

const BASE_URL = "https://www.mydatapulse.co.uk/network";

function toTitleCase(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function Network() {
  const [firstName, setFirstName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const headerRef = useRef(null);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Our Blog" },
    { to: "/get-in-touch", label: "Support" },
  ];

  const formattedName = toTitleCase(firstName.trim());
  const qrUrl = submitted
    ? `${BASE_URL}?first_name=${encodeURIComponent(formattedName)}`
    : BASE_URL;

  const handleSubmit = (e) => {
  e.preventDefault();
  if (formattedName) {
    setSubmitted(true);
    setTimeout(() => {
      headerRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100); // slight delay ensures QR is rendered
  }
};

  const resetForm = () => {
    setSubmitted(false);
    setFirstName("");
  };

  return (
    <>
      <Helmet>
        <title>Personalised Network QR | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="h-screen w-screen overflow-hidden flex flex-col">
        <div id="header" className="z-10 bg-white" ref={headerRef}>
          <Header links={navLinks} />
        </div>

        <section id="network-qr-generator" className="flex-1 bg-white flex items-center justify-center">
          <div className="max-w-screen-xl px-4 pt-32 text-center flex flex-col items-center">
            {/* My Name */}
            <h2 className="text-5xl font-extrabold tracking-tight text-title-purple text-gray-900">
              Viren Samani
            </h2>

            {/* QR Code */}
            <div className="py-10">
              <QRCodeCanvas value={qrUrl} size={225} />
            </div>

            {/* Reset Logo */}
            <button onClick={resetForm} className="mt-6" style={{ border: "none", background: "none" }}>
              <img
                className="px-5 lg:max-w-sm mx-auto cursor-pointer"
                src="https://www.mydatapulse.co.uk/icons/1.png"
                alt="logo image"
              />
            </button>

            {/* Form Input */}
            {!submitted && (
              <form onSubmit={handleSubmit} className="mt-10 flex flex-col items-center">
                <input
                  type="text"
                  placeholder="Enter first name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="border border-gray-300 px-4 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                <button
                  type="submit"
                  className="mt-4 px-5 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition"
                >
                  Generate QR
                </button>
              </form>
            )}

            {/* Optional subheading */}
            {submitted && (
              <p className="text-lg text-gray-600 mt-10">
                QR Code for: <strong>{formattedName}</strong>
              </p>
            )}

          </div>
        </section>
      </div>
    </>
  );
}

export default Network;
